import ReactHtmlParser from 'react-html-parser'
import type {
  IContentTranslation,
  IContentType,
} from '~/@api/generated-api-types-user/Api'
import { Spinner } from '~/shadcn/ui/spinner'
import { useHtmlContent } from './useHtmlContent'

type Props = {
  typeId: IContentType
  lang: string
}

function HtmlContent(props: Props) {
  const { data, isLoading, error } = useHtmlContent(props.typeId)

  const contentHtml = (() => {
    if (!data?.content) return null

    return (
      data.content[props.lang as keyof IContentTranslation] ??
      data.content.sk ??
      ''
    )
  })()

  if (isLoading) return <Spinner className="size-4" />
  if (error) return <div>Error: {error.message}</div>
  if (!contentHtml) return null

  return (
    <div className={'custom-contents'}>
      <div className={'content-item'}>{ReactHtmlParser(contentHtml)}</div>
    </div>
  )
}

export { HtmlContent }
